import { makeStyles, Theme } from '@material-ui/core/styles';

// Single source of truth for the "new UI" data-table / detail-card look.
// Used by the shared ShowData (transferRewardAmount.tsx) and userDetail.tsx,
// so restyling data tables app-wide is a one-file change.
// Colours are derived from the active MUI theme so it works in light AND dark mode.
export const useDataTableStyles = makeStyles((theme: Theme) => {
  const isDark = theme.palette.type === 'dark';
  const gridLine = isDark ? 'rgba(255, 255, 255, 0.22)' : 'rgba(28, 30, 31, 0.32)';
  const cardBorder = isDark ? 'rgba(255, 255, 255, 0.10)' : 'rgba(28, 30, 31, 0.08)';
  const cardShadow = isDark
    ? '0 8px 24px rgba(0, 0, 0, 0.45)'
    : '0 8px 24px rgba(28, 30, 31, 0.06)';
  const headerBg = isDark ? 'rgba(218, 41, 114, 0.18)' : 'rgba(218, 41, 114, 0.06)';
  const headerColor = isDark ? '#F48FB6' : '#DA2972';

  return {
    // Show the table in full (no inner scrollbar) and centre it. The wrapper
    // shrinks to the table's natural width and `margin: 0 auto` centres it when
    // it fits; a table wider than the page left-aligns and the page scrolls.
    scrollWrap: {
      width: 'max-content',
      margin: '0 auto',
    },
    // Natural column widths (like the original layout). The `display: block`
    // is applied inline per-table so wide tables size to content and overflow
    // into scrollWrap rather than wrapping every header character-by-character.
    table: {
      margin: '0 auto',
      borderTop: `1px solid ${gridLine}`,
      borderLeft: `1px solid ${gridLine}`,
    },
    tableCell: {
      padding: '8px 12px',
      borderBottom: `1px solid ${gridLine}`,
      borderRight: `1px solid ${gridLine}`,
      fontSize: '0.9rem',
      lineHeight: 1.4,
      color: theme.palette.text.primary,
      verticalAlign: 'top',
    },
    headerCell: {
      backgroundColor: headerBg,
      color: headerColor,
      fontWeight: 700,
      fontSize: '0.9rem',
    },
    accordion: {
      borderRadius: '18px !important',
      border: `1px solid ${cardBorder}`,
      boxShadow: `${cardShadow} !important`,
      margin: '0 auto 16px !important',
      maxWidth: '96%',
      overflow: 'hidden',
      '&:before': {
        display: 'none',
      },
      '&.Mui-expanded': {
        margin: '0 auto 16px !important',
      },
    },
    accordionSummary: {
      '& h3': {
        fontFamily: '"Space Grotesk", "Manrope", sans-serif',
        fontWeight: 700,
        fontSize: '1.05rem',
        color: theme.palette.text.primary,
      },
    },
    accordionDetails: {
      padding: '0 16px 16px',
      overflowX: 'auto',
    },
  };
});
